import {Component, OnInit} from '@angular/core';
import {FormControl, FormGroup} from '@angular/forms';
import {EmployeeDesignationDTO} from '../../../shared/dto/employee-designation.model';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {NgxUiLoaderService} from 'ngx-ui-loader';
import {ActionMode} from '../../../shared/enums/action-mode.enum';
import {EmployeeDesignationPopupComponent} from './employee-designation-popup/employee-designation-popup.component';
import swal from 'sweetalert2';
import {EmployeeDesignationService} from '../../../shared/service/employee-designation.service';
import {TokenStorageService} from '../../../shared/service/token-storage.service';
import {Router} from '@angular/router';

@Component({
  selector: 'app-employee-designation',
  templateUrl: './employee-designation.component.html',
  styleUrls: ['./employee-designation.component.scss']
})
export class EmployeeDesignationComponent implements OnInit {
  public employeeDesignationForm: FormGroup;
  public employeeDesignationConfigItems: EmployeeDesignationDTO [] = [];
  public href: string = '';

  constructor(public modalService: NgbModal,
              private spinnerService: NgxUiLoaderService,
              private employeeDesignationService: EmployeeDesignationService,
              private tokenStorageService: TokenStorageService,
              private router: Router) {
  }

  ngOnInit() {
    this.employeeDesignationForm = new FormGroup({
      employeeDesignation: new FormControl(null),
      code: new FormControl(null),
      description: new FormControl(null),
      states: new FormControl(null),
    });
    this.href = this.router.url;
    this.onLoadGetData();
    this.loadEmployeeDesignations();
  }

  loadEmployeeDesignations() {
    this.employeeDesignationService.getAllEmployeeDesignation().subscribe(
      (data: EmployeeDesignationDTO[]) => {
        this.employeeDesignationConfigItems = data;
      }
    )
  }

  onLoadGetData(): void {
    const designationDTO = new EmployeeDesignationDTO(
      null,
      null,
      null,
      null,
      null,
    )
    this.loadSearchResultList(designationDTO);
  }

  loadSearchResultList(employeeDesignationDTO: EmployeeDesignationDTO): void {
    this.spinnerService.start();
    this.employeeDesignationService.getEmployeeDesignationDetails(employeeDesignationDTO).subscribe(
      (data: EmployeeDesignationDTO[]) => {
        this.employeeDesignationConfigItems = data;
      },
      (error) => {
        this.spinnerService.stop();
        swal.fire('Sorry!', 'Something went wrong...!', 'error');
      },
      () => {
        this.spinnerService.stop();
        if (this.employeeDesignationConfigItems == null || this.employeeDesignationConfigItems.length === 0) {
          swal.fire('Sorry', 'No result found.', 'error');
          this.loadEmployeeDesignations();
        } else {
          this.employeeDesignationService.clearUserRoleSearchDetails();
          this.employeeDesignationService.setUserRoleSearchDetails(
            this.employeeDesignationConfigItems
          );
        }
      }
    );
  }

  onSubmitSearch(): void {
    let isValid: boolean = false;
    let msg: string = 'Please fill the form..!';

    if (this.employeeDesignationForm.value.code != null) {
      isValid = true;
    }
    if (this.employeeDesignationForm.value.description != null) {
      isValid = true;
    }
    if (this.employeeDesignationForm.value.states != null) {
      isValid = true;
    }
    if (isValid && this.employeeDesignationForm.valid) {
      const employeeDesignationDTO = new EmployeeDesignationDTO(
        this.employeeDesignationForm.value.code,
        this.employeeDesignationForm.value.description,
        this.employeeDesignationForm.value.states,
        this.tokenStorageService.getUserObjectToken().username,
        this.href
      );
      this.loadSearchResultList(employeeDesignationDTO);
      this.spinnerService.start();
    }
  }

  validateAllFormFields(formGroup: FormGroup) {

    Object.keys(formGroup.controls).forEach(field => {

      const control = formGroup.get(field);
      if (control instanceof FormControl) {

        control.markAsTouched({onlySelf: true});
      } else if (control instanceof FormGroup) {

        this.validateAllFormFields(control);
      }
    });
  }

  onClickReset() {
    this.employeeDesignationForm.reset({
      code: null,
      description: null,
      states: null,
    });
    this.onLoadGetData();
  }

  onClickNew() {
    const modalRef = this.modalService.open(EmployeeDesignationPopupComponent, {
      windowClass: 'xlModal'
    });
    // modalRef.componentInstance.name = 'Add New Employee';
    modalRef.componentInstance.selectedMode = ActionMode.ADD;
    modalRef.componentInstance.designationMgtCopy_ = this.employeeDesignationConfigItems;
    modalRef.result.then((data: string) => {
      if (data == 'Saved') {
        this.onLoadGetData();
        this.loadEmployeeDesignations();
      }
    }, () => {

    });
  }
}
